import { useState, useEffect } from "react";
import "./feed.css";
import { Star, MessageSquare,TrendingUp, Award, Quote } from "lucide-react";
import {Link} from "react-router-dom"

const feedbackData = [
  {
    id: 1,
    name: "Govardhan Reddy",
    role: "IT Employee",
    rating: 5,
    feedback: "Vijaya traders team help us to bring up the higher profit for our income to generate the passive income which helps to uplift our income lifestyle and make us very helpful. And the Vijaya Traders team helps us to understand the variety of plans with the higher benefits for users.",
    date: "2 days ago",
    category: "Service",
    avatar: "https://i.pravatar.cc/150?img=1",
  },
  {
    id: 2,
    name: "P.Hemanth",
    role: "IT Employee",
    rating: 5,
    feedback: "Trusted, payments might get delayed due to week offs but guaranteed. I have been investing since 2023 so far i never got negative impression.",
    date: "5 days ago",
    category: "Quality",
    avatar: "https://i.pravatar.cc/150?img=12",
  },
  {
    id: 3,
    name: "Sukumar",
    role: "IT Employee",
    rating: 4,
    feedback: "I have started investing from past some months in Vijaya traders, it was good experience in trading.Team helped me alot by explaining about process & return profits.on time payment I have received yet.",
    date: "1 week ago",
    category: "Delivery",
    avatar: "https://i.pravatar.cc/150?img=33",
  },
  {
    id: 4,
    name: "Jyothi Krishna",
    role: "Business Owner",
    rating: 5,
    feedback: "Hello Team,It's been six months since I started investing here, and the experience has been excellent. The returns have been consistent, and the support team is always helpful in addressing my queries. I truly appreciate their guidance and trustworthy approach.",
    date: "1 week ago",
    category: "Support",
    avatar: "https://i.pravatar.cc/150?img=13",
  },
  {
    id: 5,
    name: "T.Pavan Kumar",
    role: "Sr.Sales Executive in fertiliser company",
    rating: 5,
    feedback: "Vijaya traders team helps us to bring nice profits we have got a passive income with timely payments every month which helps very much for our monthly expenses we believe in Vijaya traders our money works when we sleep.",
    date: "2 weeks ago",
    category: "Design",
    avatar: "https://i.pravatar.cc/150?img=52",
  },
  {
    id: 6,
    name: "P.Bhanu Prakash",
    role: "Professional Stock Trader",
    rating: 4,
    feedback: "Dear vijaya traders,Thank you for your service I appreciate the timely payments and faster communication with costumer.I value your efforts and look forward to continued business with you.",
    date: "2 weeks ago",
    category: "Features",
    avatar: "https://i.pravatar.cc/150?img=14",
  },
  {
    id: 7,
    name: "Chenna Madhav",
    role: "Family Bussiness",
    rating: 5,
    feedback: "Hii Vijaya Traders Team,This is madhav,I am one of the customer from vijaya traders,I am very happy with vijaya traders,because these vijaya traders were giving profits time to time.I am sure for profitable money,just invest and travel with vijaya traders definately you will get more profits and you will be happy.So please invest and earn with Vijaya Traders.Thank you,",
    date: "3 weeks ago",
    category: "Service",
    avatar: "https://i.pravatar.cc/150?img=10",
  },
  {
    id: 8,
    name: "N.Jahnavi",
    role: "House Wife(EX-IT Employee)",
    rating: 5,
    feedback: "Vijaya Traders has demonstrated exceptional commitment to quality, transparency, and customer satisfaction. The company’s focus on maintaining strong client relationships, timely service delivery, and consistent business ethics has positioned it as a trusted name Dairy farming ",
    date: "3 weeks ago",
    category: "Performance",
    avatar: "https://i.pravatar.cc/150?img=15",
  },
];

export default function Feed() {
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [filteredFeedback, setFilteredFeedback] = useState(feedbackData);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsLoaded(true), 100);
  }, []);

  useEffect(() => {
    if (selectedFilter === "all") {
      setFilteredFeedback(feedbackData);
    } else {
      setFilteredFeedback(
        feedbackData.filter(
          (item) => item.rating === parseInt(selectedFilter)
        )
      );
    }
  }, [selectedFilter]);

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  const renderStars = (rating) => {
    return (
      <div className="stars-container">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            className={`star-icon ${i < rating ? "star-filled" : "star-empty"}`}
          />
        ))}
      </div>
    );
  };

  const stats = [
    {
      icon: Star,
      label: "Average Rating",
      value: "4.8",
      suffix: "/5",
    },
    {
      icon: TrendingUp,
      label: "Satisfaction Rate",
      value: "96",
      suffix: "%",
    },
    {
      icon: Award,
      label: "Top Rated",
      value: "5★",
      suffix: "",
    },
  ];

  const filters = [
    { value: "all", label: "All Reviews" },
    { value: "5", label: "5 Stars" },
    { value: "4", label: "4 Stars" },
    { value: "3", label: "3 Stars" },
  ];

  return (
    <div className="feedback-page">
      {/* Decorative background */}
      <div className="background-decoration">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
      </div>

      {/* Content */}
      <div className="content-wrapper">
        {/* Header */}
        <header className="header">
          <div className="header-content">
            <div className="icon-wrapper">
              <div className="icon-glow"></div>
              <div className="icon-box">
                <MessageSquare className="header-icon" strokeWidth={1.5} />
              </div>
            </div>

            <div className="title-section">
              <h1 className="main-title">
                <span className="title-white">Customer </span>
                <span className="title-gold">Feedback</span>
              </h1>
              <p className="subtitle">
                Discover what our valued customers are saying about their experience with us
              </p>
            </div>

            <div className="decorative-stars">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="decorative-star"
                  style={{ animationDelay: `${i * 0.1}s` }}
                />
              ))}
            </div>
          </div>
        </header>

        {/* Stats Section */}
        <section className="stats-section">
          <div className="stats-grid">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <div key={index} className="stat-card">
                  <div className="stat-content">
                    <div className="stat-icon-wrapper">
                      <Icon className="stat-icon" strokeWidth={2} />
                    </div>
                    <div>
                      <div className="stat-value">
                        {stat.value}
                        <span className="stat-suffix">{stat.suffix}</span>
                      </div>
                      <div className="stat-label">{stat.label}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        {/* Filter Bar */}
        <section className="filter-bar">
          <div className="filter-content">
            <h2 className="filter-title">
              <Star className="filter-star" />
              Filter Reviews
            </h2>
            <div className="filter-buttons">
              {filters.map((filter) => (
                <button
                  key={filter.value}
                  className={`filter-btn ${selectedFilter === filter.value ? "filter-btn-active" : ""}`}
                  onClick={() => setSelectedFilter(filter.value)}
                >
                  {filter.label}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Feedback Grid */}
        <section className="feedback-section">
          <div className="feedback-container">
            {filteredFeedback.length === 0 ? (
              <div className="no-results">
                <p>No feedback found for this filter.</p>
              </div>
            ) : (
              <div className="feedback-grid">
                {filteredFeedback.map((feedback, index) => (
                  <div
                    key={feedback.id}
                    className="feedback-card"
                    style={{
                      opacity: isLoaded ? 1 : 0,
                      transform: isLoaded ? "translateY(0)" : "translateY(20px)",
                      transition: `all 0.5s ease-out ${index * 0.1}s`,
                    }}
                  >
                    <div className="card-header">
                      <div className="user-info">
                        <div className="avatar">
                          {feedback.avatar ? (
                            <img src={feedback.avatar} alt={feedback.name} />
                          ) : (
                            <div className="avatar-fallback">
                              {getInitials(feedback.name)}
                            </div>
                          )}
                        </div>
                        <div>
                          <h3 className="user-name">{feedback.name}</h3>
                          <p className="user-role">{feedback.role}</p>
                        </div>
                      </div>
                      <div className="rating-badge">
                        <Star className="badge-star" />
                        {feedback.rating}
                      </div>
                    </div>

                    <div className="star-rating">{renderStars(feedback.rating)}</div>

                    <div className="feedback-content">
                      <Quote className="quote-icon" />
                      <p className="feedback-text">{feedback.feedback}</p>
                    </div>

                    <div className="card-footer">
                      <span className="feedback-date">{feedback.date}</span>
                      {feedback.category && (
                        <span className="feedback-category">{feedback.category}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div class="sp1">
          <Link to="/"><button className="backk">Back</button></Link>
          </div>
        </section>
      </div>
    </div>
  );
}
